import superSearch from '@codewell/super-search'
import { Typography } from 'procyon-ui'
import React from 'react'

export const options = (onView) => ({
  filterType: 'none',
  rowsPerPage: 10,
  download: false,
  print: false,
  filter: false,
  search: false,
  viewColumns: false,
  pagination: true,
  onRowClick: onView,
  rowsPerPageOptions: [5, 10, 15, 100],
  customSearch: (searchText, row) =>
    superSearch(searchText.toLowerCase(), { ...row }).numberOfMatches > 0,
  customToolbar: ({ displayData }) => null,
  customToolbarSelect: () => null,
  selectableRowsHideCheckboxes: true
})

export const columns = (onUserClick, viewMode) => [
  {
    dataIndex: 'UserName',
    title: 'User',
    align: 'left',
    sorter: (a, b) => a.UserName?.label?.localeCompare(b.UserName?.label),
    render(value) {
      const isClickable = viewMode !== 'user'
      return (
        <Typography
          variant='body-regular'
          {...(isClickable && {
            onClick: (e) => {
              e.stopPropagation()
              onUserClick(value.userId)
            }
          })}
          style={{
            cursor: isClickable ? 'pointer' : 'default',
            color: isClickable ? 'var(--color-primary)' : 'var(--color-font-base)'
          }}
        >
          {value.label}
        </Typography>
      )
    }
  },
  {
    dataIndex: 'DeviceName',
    title: 'Device Name',
    align: 'left',
    sorter: (a, b) => a.DeviceName.sort.localeCompare(b.DeviceName.sort),
    render(value) {
      return <Typography variant='body-regular'>{value.name}</Typography>
    }
  },
  {
    dataIndex: 'OperatingSystem',
    title: 'OS',
    align: 'left',
    sorter: (a, b) => a.OperatingSystem.localeCompare(b.OperatingSystem),
    render(value) {
      return <Typography variant='body-regular'>{value}</Typography>
    }
  },
  {
    dataIndex: 'Model',
    title: 'Model',
    align: 'left',
    sorter: (a, b) => a.Model.localeCompare(b.Model),
    render(value) {
      return <Typography variant='body-regular'>{value}</Typography>
    }
  },
  {
    dataIndex: 'CreatedAt',
    title: 'Onboarded At',
    align: 'left',
    sorter: (a, b) => a.CreatedAt.localeCompare(b.CreatedAt),
    render(value) {
      return <Typography variant='body-regular'>{value}</Typography>
    }
  }
]
